import { Button, Flex, Typography, emailRegex } from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';

export interface ForgotPasswordProps {
  /** Errors from the reset-password request. */
  errors?: string[] | null;

  /** Function called when the Cancel button is clicked (returns to the previous screen). */
  onCancel(): void;

  /** Function called when the form is submitted. */
  onSubmit(data: EmailFormData): void;
}

export type EmailFormData = {
  email: string;
};

export const ForgotPassword = ({
  errors,
  onCancel,
  onSubmit,
}: ForgotPasswordProps) => {
  return (
    <Form name="forgot-password" onSubmit={onSubmit}>
      <Flex width="100%" flexDirection="column" alignItems="center">
        <Typography branded variant="h2-semibold" textAlign="center" mb={8}>
          Reset your password
        </Typography>
        <Typography textAlign="center">
          Enter your email address below and we&rsquo;ll send you an email with
          instructions for creating a new password.
        </Typography>
        <Form.TextField
          autoFocus
          type="email"
          autocomplete="email"
          label="Email"
          name="email"
          required
          requiredLabel
          requiredMessage="Please enter your email address."
          errorMessage="Please enter a valid email address (e.g., name@example.com)."
          errorOnBlur
          disableMobileInputStyling
          pattern={emailRegex}
          my={24}
        />
        {errors && errors.length > 0 && (
          <Flex flexDirection="column" mt={-12} mb={12}>
            {errors.map((error) => (
              <Typography key={error} color="error" textAlign="center">
                {error}
              </Typography>
            ))}
          </Flex>
        )}

        <Form.SubmitButton full variant="primary" label="Submit" mb={16} />
        <Button full variant="tertiary" label="Cancel" onClick={onCancel} />
      </Flex>
    </Form>
  );
};
